<div class="modal-header d-flex align-items-center">
  <i
    class="fas fa-exclamation-circle text-danger mr-2"
    style="font-size: 1.25em"></i>
  <h5 class="modal-title" id="modal-title">{{ title }}</h5>
  <button
    class="close"
    (click)="modal.close(false)"
    type="button"
    aria-label="Close button"
    aria-describedby="modal-title">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="padding-top: 0px">
  <div [innerHTML]="text"></div>
</div>
<div class="modal-footer standard-footer">
  <app-standard-footer-buttons
    [secondaryLabel]="'Cancelar'"
    [primaryLabel]="'Confirmar'"
    [isPrimaryDisabled]="false"
    [isLoading]="false"
    [isPrimaryDanger]="true"
    (secondaryClick)="modal.dismiss()"
    (primaryClick)="modal.close(true)">
  </app-standard-footer-buttons>
</div>
